export default "__VITE_ASSET__$n9UQtIc__"